import React from 'react';
import { Grid, Card, CardContent, Typography, Alert } from '@mui/material';
import HyperVergeKYB from 'src/components/HyperVergeKYB';
import KYBUserData from 'src/components/kyb/KYBUserData';
import { FormData } from './types';

interface BusinessInfoStepProps {
  formData: FormData;
  hyperVergeStatus: string | null;
  setHyperVergeStatus: (status: string | null) => void;
  renderStepContent: (step: number) => React.ReactNode;
  isAutoApproved?: boolean;
}

const BusinessInfoStep: React.FC<BusinessInfoStepProps> = ({
  formData,
  hyperVergeStatus,
  setHyperVergeStatus,
  renderStepContent,
  isAutoApproved = false,
}) => (
  <Grid container spacing={3} alignItems="stretch" sx={{
    width:'100%',
  
  }}>
    {isAutoApproved ? (
      <Grid  sx={{
        width:'100%',

      }}>
        <Card variant="outlined"  style={{
         width:'100%'
        }}>
     
            <Alert severity="success" sx={{ mb: 2 }}>
              <Typography variant="h6" gutterBottom>
                KYB Auto-Approved! 🎉
              </Typography>
              <Typography variant="body2">
                Your KYB verification has been automatically approved. You can now proceed with the form.
              </Typography>
            </Alert>
            <KYBUserData />
       
        </Card>
      </Grid>
    ) : (
      // HyperVerge component when not auto approved
      <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column' }}>
        <Card variant="outlined" sx={{ flex: 1 }}>
          <CardContent sx={{ height: '100%' , width:'100%'}}>
            <HyperVergeKYB
              onStatusChange={setHyperVergeStatus}
            />
          </CardContent>
        </Card>
      </Grid>
    )}
   
  </Grid>
);

export default BusinessInfoStep; 